import { render, staticRenderFns } from "./OldPartsDetailsLayer.vue?vue&type=template&id=8ffd5db2&scoped=true&"
import script from "./OldPartsDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./OldPartsDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./OldPartsDetailsLayer.vue?vue&type=style&index=0&id=8ffd5db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd5db2",
  null
  
)

export default component.exports